/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesInviteEmailInviteStatusRequest
 */
export interface FxIdWebFeaturesInviteEmailInviteStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesInviteEmailInviteStatusRequest
     */
    Token: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesInviteEmailInviteStatusRequest
     */
    Game: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesInviteEmailInviteStatusRequest
     */
    EmailInviteToken: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesInviteEmailInviteStatusRequest interface.
 */
export function instanceOfFxIdWebFeaturesInviteEmailInviteStatusRequest(value: object): value is FxIdWebFeaturesInviteEmailInviteStatusRequest {
    if (!('Token' in value) || value['Token'] === undefined) return false;
    if (!('Game' in value) || value['Game'] === undefined) return false;
    if (!('EmailInviteToken' in value) || value['EmailInviteToken'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesInviteEmailInviteStatusRequestFromJSON(json: any): FxIdWebFeaturesInviteEmailInviteStatusRequest {
    return FxIdWebFeaturesInviteEmailInviteStatusRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesInviteEmailInviteStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesInviteEmailInviteStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'Token': json['Token'],
        'Game': json['Game'],
        'EmailInviteToken': json['EmailInviteToken'],
    };
}

export function FxIdWebFeaturesInviteEmailInviteStatusRequestToJSON(json: any): FxIdWebFeaturesInviteEmailInviteStatusRequest {
    return FxIdWebFeaturesInviteEmailInviteStatusRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesInviteEmailInviteStatusRequestToJSONTyped(value?: FxIdWebFeaturesInviteEmailInviteStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Token': value['Token'],
        'Game': value['Game'],
        'EmailInviteToken': value['EmailInviteToken'],
    };
}

